import ReactGA from "react-ga4";

export const useAnalyticsEventTracker = (recommended = false) => {
  const recommendedTracker = (params = {}) => {
    ReactGA.send(params);
  };

  const customTracker = (name, params = {}) => {
    ReactGA.event(name, params);
  };
  return recommended ? recommendedTracker : customTracker;
};
